import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import SimilarProductCarousel from './SimilarProductCarousel';
import FocusTrap from 'focus-trap-react';
import analytics from '@common/utils/analytics';
import classNames from 'classnames';
const ShowSimilarProductFloating = (props) => {
    var _a;
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const [visible, setVisible] = useState(false);
    const [showFloatingModal, setShowFloatingModal] = useState(true);
    const [floatingModuleMargin, setFloatingModuleMargin] = useState(false);
    const numberProductImgVisible = (_a = props.similarProductsTiles) === null || _a === void 0 ? void 0 : _a.slice(0, 2);
    // OE-24564 floating visible after loading images
    const handleFloatingVisibility = () => {
        let floatingImagesLoaded = 0;
        const images = document.querySelectorAll('.similar-product-floating--img');
        images.forEach((img) => {
            img.addEventListener('load', (event) => {
                floatingImagesLoaded++;
                if (floatingImagesLoaded == 2) {
                    setVisible(true);
                }
            });
        });
    };
    useEffect(() => {
        handleFloatingVisibility();
    }, [props.product]);
    useEffect(() => {
        // remove live chat icon when the modal opens
        document.body.classList.toggle('remove-live-chat-icon', expanded);
        document.body.classList.toggle('no-scroll', expanded);
        // add margin bottom to Floating Module when sticky bar appears
        let stickyBarOpen = document.querySelector('.sticky-tray.show');
        setFloatingModuleMargin(stickyBarOpen && !expanded);
        return () => {
            document.body.classList.remove('remove-live-chat-icon');
            document.body.classList.remove('no-scroll');
        };
    });
    return (React.createElement(React.Fragment, null, createPortal(React.createElement("div", { className: classNames('similar-product-floating', { 'expanded': expanded }, { 'visible': visible }), role: "dialog", "aria-hidden": "true" },
        React.createElement("div", { className: `similar-product-floating-inner ${floatingModuleMargin ? 'floating-margin-bottom' : ''}` },
            !expanded && (React.createElement("div", { className: "similar-product-floating-inner-text" },
                React.createElement("button", { className: "similar-product_btn text-uppercase", tabIndex: -1, onClick: () => {
                        setExpanded(true);
                        setShowFloatingModal(true);
                        analytics.productImpressionsRecommended(props.similarProductsTiles, 'pdp');
                        analytics.openFloatingModule();
                    } },
                    React.createElement("span", null, t('similarproduct.floatingbutton')),
                    React.createElement("ul", { className: "similar-product-floating--icon-images row" }, numberProductImgVisible === null || numberProductImgVisible === void 0 ? void 0 : numberProductImgVisible.map((t) => (React.createElement("li", { key: t.uuid },
                        React.createElement("img", { className: 'similar-product-floating--img', src: t.imgs.urls.find((u) => !u.includes('_F')), alt: "" })))))),
                React.createElement("button", { className: "button close", "aria-label": t('button.close'), tabIndex: -1, onClick: () => props.onFloatingClose() },
                    React.createElement("i", { className: "icon--close" })))),
            expanded && showFloatingModal && (React.createElement(FocusTrap, { active: props.similarProductsTiles.length > 0 },
                React.createElement("div", null,
                    React.createElement(SimilarProductCarousel, { similarProductsTiles: props.similarProductsTiles, swiperConf: { slidesPerView: 3 }, labelVisible: true, floatingModule: true, setShowFloatingModal: setShowFloatingModal, setExpanded: setExpanded })))))), document.body)));
};
export default ShowSimilarProductFloating;
